import http from "@/settings/apiSettings"

class RoluriDrepturiService {
  // --- AUTH_Roluri ---
  getRoluri(): Promise<any> {
    return http.clientAuth.get("/AUTH_Roluri/GetRoluri");
  }
  getRolById(id: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_Roluri/GetRolByID/${id}`);
  }
  addRol(data: { Cod: string; Nume: string; Explicatie?: string }): Promise<any> {
    return http.clientAuth.post("/AUTH_Roluri/AddRol", data);
  }
  updateRol(data: { ID: string; Cod: string; Nume: string; Explicatie?: string }): Promise<any> {
    return http.clientAuth.put("/AUTH_Roluri/UpdateRol", data);
  }
  deleteRol(id: string): Promise<any> {
    return http.clientAuth.delete(`/AUTH_Roluri/DeleteRole/${id}`);
  }

  // --- AUTH_DrepturiRoluri ---
  getMeniuriRol(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_DrepturiRoluri/GetMeniuri/${rolId}`);
  }
  addDreptRol(data: { RolId: string; AgentId: string; Citeste: boolean; Modifica: boolean; Sterge: boolean; Tip: string }): Promise<any> {
    return http.clientAuth.post("/AUTH_DrepturiRoluri/AddDrepturiRoluri", data);
  }
  deleteDreptRol(data: { RolId: string; AgentId: string; Tip: string; RightId?: string | null }): Promise<any> {
    return http.clientAuth.delete("/AUTH_DrepturiRoluri/DeleteDrepturiRoluri", { data });
  }
  updateDreptRol(rightId: string, data: { Citeste?: boolean; Modifica?: boolean; Sterge?: boolean }): Promise<any> {
    return http.clientAuth.patch(`/AUTH_DrepturiRoluri/UpdateDrepturiRoluri/${rightId}`, data);
  }
  copyRights(data: { SourceRoleId: string; TargetRoleId: string }): Promise<any> {
    return http.clientAuth.post("/AUTH_DrepturiRoluri/CopyRights", data);
  }

  // --- AUTH_RoluriUtilizatori ---
  getCompanyUsers(): Promise<any> {
    return http.clientAuth.get("/AUTH_Users/GetUsers");
  }
  getRoleUsers(rolId: string): Promise<any> {
    return http.clientAuth.get(`/AUTH_RoluriUtilizatori/GetUtilizatori/${rolId}`);
  }
  addRoleUser(userId: string, rolId: string): Promise<any> {
    return http.clientAuth.post("/AUTH_RoluriUtilizatori/AddRolUtilizator", { UserID: userId, RolID: rolId });
  }
  removeRoleUser(userId: string, rolId: string): Promise<any> {
    return http.clientAuth.delete("/AUTH_RoluriUtilizatori/RemoveRolUtilizator", { data: { UserID: userId, RolID: rolId } });
  }

  // --- Switch companie (simulator SuperAdmin) ---
  switchCompany(companyId: string): Promise<any> {
    return http.clientAuth.post("/auth/switch-company", { CompanyID: companyId }).then((res: any) => {
      if (res?.data?.token) {
        localStorage.setItem("ERA_Jwt", res.data.token);
      }
      return res;
    });
  }
}

export default new RoluriDrepturiService();
